<template>
  <div class="main">
    <div class="head">
      <div class="head-content">
        <div class="banner">
          <div class="timeClass">
            运行时长:{{ runTime }}
          </div>
          <div class="bannerTitle">{{ projectTitle }}</div>
          <div class="menuClass">
            <div class="menuContent">
              <a class="menuItem" href="http://code.scentralit.com:60001">
                <img src="../assets/homeimg/link_icon.png" alt="">
                <span>采集仪</span>
              </a>
              <div class="menuItem">
                <el-dropdown class="avatar-container" trigger="click">
                  <div class="avatar-wrapper">
                    <img src="../assets/homeimg/project_icon.png" alt="">
                    <span>项目</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <el-dropdown-menu>
                    <el-dropdown-item v-for="(item,index) in navListTitle" :key="item.id">
                      <span :style="[{color:item.id==mainId?'#409EFF':'#000000'}]"
                            @click="setFoundation(item.id,item.name)">{{ item.name }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="menuItem" @click="backProjectChoose()">
                <img src="../assets/homeimg/home_icon.png" alt="">
                <span>首页</span>
              </div>
              <div class="menuItem">
                <img src="../assets/homeimg/name_icon.png" alt="">
                <span>{{ username }}</span>
              </div>
              <div class="menuItem" @click="logout">
                <img src="../assets/homeimg/loginout_icon.png" alt="">
                <span>退出</span>
              </div>
            </div>
          </div>
        </div>
        <el-row class="head-class">
          <el-col :span="4" class="tab-logo">
            <img :src="logoMainUrl" class="logo">
          </el-col>
          <el-col :span="20" class="data-tab-content">
            <div class="data-tab">
              <ul style="list-style: none;margin: 0;padding: 0;">
                <li
                  @click="selectNav(item.title,cursor=index,item.url,)"
                  v-for="(item,index) in tabBarImgArr"
                  :key="item.url">
                  <div :class="[isSelect===item.title ? 'showFont' : 'hideFont']"
                       style="font-size: 16px;">
                    <img :src="isSelect === item.title ? item.iconshow : item.icon"
                         alt=""><span>{{ item.name }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="clear:both"></div>
    <router-view class="view_height" v-if="showRouter"></router-view>
    <!--      底部-->
    <img class="footerImg" src="../assets/homeimg/footer.png" alt="">
  </div>

</template>

<script>
// import HomeFooter from './Footer'

export default {
  components: {
    // HomeFooter,
  },
  data() {
    return {
      systemType: localStorage.getItem("systemType"),//系统类型
      mainId: localStorage.getItem('mainId'),
      cursor: 0, //默认选中第一个tab,
      isSelect: 'menu1',
      tabBarImgArr: [
        {
          title: 'menu1',
          name: '实时监测',
          iconshow: require("../assets/images/menu1.png"),
          icon: require("../assets/images/menu1_click.png"),
          normal: require("../assets/img/menu01.png"),
          selected: require('../assets/img/menu01_dark.png'),
          url: localStorage.getItem("systemType") === '1' ? 'realTimeData' : 'realTimeData2d'
        },
        {
          title: 'menu2',
          name: '数据管理',
          icon: require("../assets/images/menu2_click.png"),
          iconshow: require("../assets/images/menu2.png"),
          normal: require("../assets/img/menu02.png"),
          selected: require('../assets/img/menu02_dark.png'),
          url: 'dataChart'
        },
        {
          title: 'menu3',
          name: '安全评价',
          icon: require("../assets/images/menu3_click.png"),
          iconshow: require("../assets/images/menu3.png"),
          normal: require("../assets/img/menu03.png"),
          selected: require('../assets/img/menu03_dark.png'),
          url: 'evaluation'
        },
        {
          title: 'menu4',
          name: '报表管理',
          icon: require("../assets/images/menu4_click.png"),
          iconshow: require("../assets/images/menu4.png"),
          normal: require("../assets/img/menu04.png"),
          selected: require('../assets/img/menu04_dark.png'),
          url: 'dayreport'
        },
        {
          title: 'menu5',
          name: '工程信息',
          icon: require("../assets/images/menu5_click.png"),
          iconshow: require("../assets/images/menu5.png"),
          normal: require("../assets/img/menu05.png"),
          selected: require('../assets/img/menu05_dark.png'),
          url: 'ProjectInfo'
        },
        {
          title: 'menu6',
          name: '系统设置',
          icon: require("../assets/images/menu6_click.png"),
          iconshow: require("../assets/images/menu6.png"),
          normal: require("../assets/img/menu06.png"),
          selected: require('../assets/img/menu06_dark.png'),
          url: 'interfaceSetting'
        }
      ],
      showRouter: true,
      navListTitle: [],//顶部项目下拉
      timer1: '',
      timer2: '',
      time_date: '',
      time_hour: '',
      time_mimute: '',
      nowTime: '',
      runTime: "",
      runTimeInterval: null,
      projectStartTime: "",
      projectTitle: "",
      logoMainUrl: ""
    };
  },
  computed: {
    username() {
      return localStorage.getItem('username');
    }
  },
  mounted: function () {
    (function () { //适配设置基础rem
      function w() {
        var r = document.documentElement;
        var a = r.getBoundingClientRect().width;//获取当前设备的宽度
        // console.log(a,'获取当前设备的宽度s');
        if (a < 1280) { //414不固定，根据设计稿的宽度定
          a = 1280;
        }
        r.style.fontSize = a / 130 + "px"
      }

      w();
      window.addEventListener("resize", function () { //监听横竖屏切换
        w()
      }, false);
    })();
    // 修改 tabBarImgArr 的某些值
    let mainId = localStorage.getItem("mainId");
    console.log("mainId"+mainId);
    if (mainId == 158 || mainId == 137 || mainId == 138 || mainId >= 213) {
      // 找到 menu3 并修改其属性
      const tabItem = this.tabBarImgArr.find(item => item.title === 'menu4');
      if (tabItem) {
        tabItem.url = 'dayReportNew';
      }
    }
    if (sessionStorage.getItem('cursor') == null) {
      this.cursor = 0;
    }
    if (sessionStorage.getItem('isSelect') == null) {
      this.isSelect = 'menu1';
    }
    if (sessionStorage.getItem('cursor') || sessionStorage.getItem('isSelect')) {
      this.cursor = sessionStorage.getItem('cursor');
      this.isSelect = sessionStorage.getItem('isSelect');
      this.selectNav(this.isSelect, this.cursor);
    }

    let _this = this;
    this.getProjectMainInfo()
    _this.getDataInit()
    // _this.timer1 = setInterval(function () {
    //     _this.getRunData(_this.navListTitle)
    // }, 1000 * 60 * 60 * 24)
  },
  beforeDestroy() {
    clearInterval(this.runTimeInterval)
  },
  methods: {
    getProjectMainInfo() {
      this.$axios.get('/api/monitor/index/indexMainInfo').then(res => {
        let data = res.data
        if (data.datas) {
          let datas = data.datas
          if (datas.values) {
            let values = datas.values
            this.projectTitle = values.projectMainName
            localStorage.setItem('projectTitle', this.projectTitle)
            localStorage.setItem('websocketUrl', values.websocketUrl)
            this.projectStartTime = values.startTime
            this.logoMainUrl = values.logoMainUrl
            this.getRunTime()
            this.runTimeInterval = setInterval(() => {
              this.getRunTime()
            }, 1000)
          }
        }
      })
    },
    getRunTime() {
      let nowTime = new Date().getTime()
      let projectStartTime = new Date(this.projectStartTime).getTime()
      let runTime = nowTime - projectStartTime
      let day = Math.floor(runTime / (24 * 3600 * 1000))
      let leave1 = runTime % (24 * 3600 * 1000)
      let hours = Math.floor(leave1 / (3600 * 1000))
      let leave2 = leave1 % (3600 * 1000)
      let minutes = Math.floor(leave2 / (60 * 1000))
      let leave3 = leave2 % (60 * 1000)
      let seconds = Math.round(leave3 / 1000)
      this.runTime = day + '天' + hours + '小时' + minutes + '分' + seconds + '秒'
    },
    getRunData(title) {
      let arr = title
      let Str = []
      arr.forEach(item => {
        Str.push(item.id)
      })
      this.$axios.get('/api/monitor/index/getRunTime?childProjectIds=' + Str.toString()).then(res => {
        if (res.data.status == 200) {
          let timeStr = res.data.datas.values;
          if (timeStr !== '') {
            let _this = this;
            _this.time_date = timeStr.split('天')[0];
            _this.timer2 = setInterval(function () {
              _this.realTime = _this.dealWithTime(new Date()) // 修改数据date
            }, 1000)

          } else {
            this.time_date = '0'
            this.time_hour = '00'
            this.time_mimute = '00'
            this.nowTime = '00'
          }
        }
        return
      })
    },
    /*获取当前时间*/
    dealWithTime(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      this.time_hour = hh
      this.time_mimute = mm
      this.nowTime = ss
    },
    //加载页面，获取数据
    getDataInit() {
      this.$axios.get('/api/monitor/index/indexinit').then((res) => {
        if (res.data.status === 200) {
          this.navListTitle = []
          this.navListTitle = res.data.datas.values.childProjectList.slice(0)
          // this.getRunData(this.navListTitle)
        }
      })
    },
    //项目下拉
    setFoundation(id, name) {
      if (id == null || id == 0) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      });
      // return;
      this.$axios.get('/api/monitor/model/decision/systemType?id=' + id).then(res => {
        if (this.showRouter) {
          this.showRouter = false;
          setTimeout(() => {
            this.showRouter = true
          }, 1)
        }
        if (res.data.status === 200) {
          let childProject = res.data.datas.values.childProject;
          if (childProject != null) {
            localStorage.setItem("mainId", childProject.id);
            this.mainId = childProject.id
            localStorage.setItem("systemType", childProject.systemType);
            localStorage.setItem("url", "http://detect.scentralit.com:9095/image/");
            // this.getData()
            if (childProject.systemType == "1") {//3D
              localStorage.setItem("path", res.data.datas.values.bimViewToken)
              localStorage.setItem("currentpoint", res.data.datas.values.childProject.childProjectType3d.modelView)
              this.$router.replace({name: 'realTimeData',});
            } else {
              localStorage.setItem("path", childProject.childProjectType2d.projectPicPath);
              this.$router.replace({name: 'realTimeData2d'})
            }
          }
          loading.close();
        } else {
          loading.close();
        }

      }).catch(() => {
        loading.close();
      })
      // clearTimeout(time);
    },
    setImg(ele, url, title) {
      if (this.isSelect === title) {
        return;
      }
    },
    backProjectChoose() {
      this.$router.push({path: '/ProjectChoose'});
      sessionStorage.removeItem('cursor');
      sessionStorage.removeItem('isSelect');
    },
    logout() {
      this.$axios.get("/api/auth/auth/logout ").then(res => {
        let projectCode = localStorage.getItem("projectCode");
        localStorage.clear();
        if (projectCode) {
          this.$router.replace({path: '/', query: {projectCode: projectCode}})
        } else {
          this.$router.replace({path: '/'});
        }
      })
    },
    selectNav(title, cursor, url) {
      this.isSelect = title;
      this.$router.push({name: url});
      sessionStorage.setItem('cursor', cursor);
      sessionStorage.setItem('isSelect', title);
    },
    camera() {
      // console.log('摄像头代码，等需要的时候再用');
      // 打开一个新页面
      // window.open("http://192.168.2.28:9999/play.html?serial=34020000001320000072&code=34020000001320000001");
      // 本页面打开
      // window.location.href="http://192.168.2.28:9999/play.html?serial=34020000001320000072&code=34020000001320000001"
      /* // 打开新窗口
      let routeData = this.$router.resolve({
          path: "/Example",
          // query: {id:96}
      });
      window.open(routeData.href, '_blank'); */
    }
  },
  destroyed() {//页面关闭时监听
    let _this = this
    clearInterval(_this.timer1)
    clearInterval(_this.timer2)
  },
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: #ffffff;
}

/**{*/
/*  padding:0;margin:0;list-style:none*/
/*}*/
/*顶部导航*/
.banner {
  height: 7%;
  min-height: 4rem;
  width: 100%;
  background-image: url("../assets/homeimg/banner.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.timeClass {
  width: 28%;
  /*border: 1px springgreen solid;*/
  height: 2rem;
  line-height: 2rem;
  font-size: 1.2rem;
  color: #FFFFFF;
  margin-left: 4%;
  cursor: pointer;
}

/*标题*/
.bannerTitle {
  width: 42%;
  text-align: center;
  font-size: 2.1rem;
  font-weight: bold;
  color: #FFFFFF;
  /*border: 1px solid red;*/
  /*letter-spacing:5px;*/
}

/*导航栏菜单项*/
.menuClass {
  width: 28%;
  /*border: 1px springgreen solid;*/
  height: 2rem;
  color: #FFFFFF;
  margin-right: 4%;
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.menuContent {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.menuContent .menuItem:nth-of-type(1) {
  width: 20.5%;
}

.menuContent .menuItem:nth-of-type(2) {
  width: 17.5%;
}

.menuItem {
  cursor: pointer;
  width: 16.5%;
  margin: 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.avatar-wrapper img {
  width: 1.75rem;
  height: 1.75rem;
}

.avatar-wrapper span {
  color: #FFFFFF;
  font-size: 1rem;
}

.avatar-wrapper i {
  margin-top: 0.15rem;
  font-size: 0.6rem;
  font-weight: bold;
  color: #FFFFFF;
}

[class*=" el-icon-"], [class^=el-icon-] {
  font-size: 16px !important;
}

.avatar-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

/*/deep/.avatar-container .el-dropdown-menu__item span{*/
/*  padding: 0 10px !important;*/
/*}*/
/*/deep/  .el-dropdown-menu{*/
/*  background-color: #0d5477 !important;*/
/*  border: 1px solid red;*/
/*!*  36,105,231,0.31*!*/
/*}*/
/*/deep/ .el-dropdown-menu__item:not(.is-disabled) {*/
/*  color: rgba(36,105,231,0.31);*/
/*}*/
/*/deep/ .el-dropdown-menu {*/
/*  background-color: red !important;*/
/*  color: black;*/
/*}*/

.view_height {
  height: calc(100% - 190px);
}

/*  底部样式*/
.footerImg {
  margin-top: 8px;
  width: 100%;
  height: 20px;
}

.main {
  background: url('../assets/image/monitor_bg.png');
  margin: auto;
  min-width: 1200px;
  width: 100%;
  /*position: relative;*/
  position: fixed;
  height: 100%;
}

.head {
  margin-bottom: 1rem;

}

.head-content {
  position: relative;
  height: 9.5rem;
}


.head-icon {
  position: absolute;
  z-index: 99;
  //obsolute点击事件不生效，添加该行代码即可 top: 0; right: 0;
}

.head-nav {
  position: absolute;
  top: 5px;
}

.head .logo {
  width: 100%;
}

.head_menu {
  float: right;
  margin-right: 30px;
  margin-top: 4px;
  margin-bottom: 4px;

}

.head_menu ul {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.head_menu span {
  margin-right: 1px;
}

.head_menu ul li {
  display: inline-block;
}

.head_menu ul li img {
  height: 26px;
}

.user_name {
  color: #4e9ad3;
}

.backhome {
  margin-right: 22px;
}

.user {
  margin-right: 22px;
}

.sys_menu {
  float: left;
  margin-top: 30px;
  width: calc(100% - 250px);
}

.sys_menu li {
  width: 16.6666666%;
  display: inline-block;
  text-align: center;
  margin-right: -5px;
}

.head-class {
  width: 100%;
  position: absolute;
  top: 5rem;
  height: 5rem;
  line-height: 5rem;
  /*border: 1px solid red;*/
}

.tab-logo {
  position: relative;
  top: 1rem;
  height: 3rem;
  line-height: 3rem;
  padding: 0 35px;

}

/* 项目Tab样式 */
.data-tab-content {
  margin-top: 0.5rem;
  /*border: 1px solid red;*/
  position: relative;
  height: 4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.data-tab {
  width: 100%;
  height: 100%;
}

.data-tab ul {
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.data-tab li {
  transition: all 0.1s ease;
  cursor: pointer;
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 15.2%;
  background-image: url(../assets/newimg/titlebg.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.data-tab li:hover {
  background-image: url(../assets/newimg/titlehover.png);
}

.data-tab li:last-child {
  margin-right: 30px;
  padding: 0;
}

.showFont {
  color: #FFFFFF;
}

.hideFont {
  color: #A7CCF6;
}

.data-tab li div {
  height: 100%;
  font-size: 1.45rem !important;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.data-tab li div img {
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 0.65rem;
}

.warn_panel {
  position: absolute;
  width: 200px;
  padding: 10px;
  right: 0;
  color: red;
  top: 140px;
  max-height: 400px;
  overflow: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/main.vue